import { isDevelopmentMode, sendRequest } from "../base";

export const getCurrentReport = () => {
  return sendRequest(
    isDevelopmentMode() ? "/cms/summary-report" : "/content/current_report/"
  );
};

export const getSystemContents = () => {
  return sendRequest(
    isDevelopmentMode() ? "/cms/system-contents" : "/content/current_report/"
  );
};
